module.exports = __webpack_public_path__ + "img/jo.5a774ea7.svg";